import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DriverService } from '../../services/driver-service/driver.service';

@Component({
  selector: 'driver-vehicle-select',
  templateUrl: './driver-vehicle-select.component.html',
  styleUrls: ['./driver-vehicle-select.component.css']
})
export class DriverVehicleSelectComponent implements OnInit {
  /**
   * When true, merge portal drivers into the list.
   * Portal list is loaded from GET /driver/?isPortal=true (active portal drivers for the client).
   */
  @Input() includePortalDrivers = false;

  @ViewChild('driverSearch') driverSearch: ElementRef;
  @Output() driverSelected: EventEmitter<any> = new EventEmitter();
  @Output() vehicleSelected: EventEmitter<any> = new EventEmitter();
  filteredDrivers = [];
  drivers = [];
  vehicles = [];
  selectedVehicle = null;
  selectedDriver;
  constructor(private driverService:DriverService) { }

  ngOnInit() {
    if (this.includePortalDrivers) {
      const platform$ = this.driverService.getDrivers().then((r: any) =>
        this.driverService.mapDriverApiResponse(r || {}));
      const portal$ = this.driverService.getDrivers(null, { isPortal: true }).then((r: any) =>
        this.driverService.mapDriverApiResponse(r || {}));
      Promise.all([platform$, portal$]).then(([platformDrivers, portalDrivers]) => {
        const plat = Array.isArray(platformDrivers) ? platformDrivers : [];
        const port = Array.isArray(portalDrivers) ? portalDrivers : [];
        this.drivers = plat.concat(port);
        this.filteredDrivers = this.drivers;
      }).catch(() => {
        this.driverService.getDrivers().then((results: any) => {
          this.drivers = this.driverService.mapDriverApiResponse(results || {});
          this.filteredDrivers = this.drivers;
        });
      });
      return;
    }
    this.driverService.getDrivers().then((results: any) => {
      this.drivers = this.driverService.mapDriverApiResponse(results || {});
      this.filteredDrivers = this.drivers;
    });
  }

  onDriverSelect(driver) {    
    this.selectedDriver = driver;
    this.selectedVehicle = null;
    this.vehicles = [];
    if (this.includePortalDrivers && driver && driver.isPortalDriver && driver.portalDriverId != null) {
      const label = (driver.vehicleName && String(driver.vehicleName).trim()) ? String(driver.vehicleName).trim() : 'Portal vehicle';
      this.vehicles = [{
        vehicleid: 0,
        year: '',
        make: '',
        model: label
      }];
      this.selectedVehicle = 0;
      this.driverSelected.emit(driver);
      this.vehicleSelected.emit(0);
      return;
    }
    this.driverService.getVehicles(this.selectedDriver.driverid).then((res) => {
      this.vehicles = res.data || [];
    });
    this.driverSelected.emit(this.selectedDriver);
  }
  
  onVehicleSelect(){
    this.vehicleSelected.emit(this.selectedVehicle);
  }

  onDriverSearch(event) {
    if (!this.driverSearch.nativeElement.value) {
      this.filteredDrivers = this.drivers;
    } else {
      this.filteredDrivers = this.drivers.filter(x =>
        (`${x.firstname} ${x.lastname}`.toLocaleLowerCase()).includes(this.driverSearch.nativeElement.value.toLocaleLowerCase())
      );
    }
  }


}
